'use client'

import Section from '../molecules/section'; // Ensure this import is correct
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Link from 'next/link';

const LapDogs = () => {
    const t = useTranslations('LapDogs');
    return (
        <Section
            id="lapdogs"
            backgroundImage="/images/lapdogs.avif"
            className="relative flex flex-col min-h-screen items-center justify-center bg-no-repeat bg-cover"
        >
            {/* Dark overlay */}
            <div className="absolute inset-0 bg-black opacity-50"></div>

            {/* Top gradient */}
            <div className="absolute inset-x-0 top-0 h-72 bg-gradient-to-b from-black to-transparent"></div>

            {/* Bottom gradient */}
            <div className="absolute inset-x-0 bottom-0 h-72 bg-gradient-to-t from-black to-transparent"></div>

            <div className="relative flex flex-col items-center text-center px-4 pt-32 pb-64 xs:space-y-12 sm:space-y-12 md:space-y-12 lg:space-y-12">
                <p className="text-white text-sm font-bold uppercase leading-6 lg:w-[60%] w-full font-sora">
                    {t('title')}
                </p>
                <Image
                    src="/logos/lapdogs.png"
                    width={500}
                    height={500}
                    className="rounded-3xl"
                    sizes="100%"
                    alt="lapdogs-logo"
                />
                <p className="m-auto lg:w-[45%] w-full text-white text-base font-normal leading-6 mt-2 font-sora">
                    {t('description')}
                </p>
                <div className="w-64">
                    <Link
                        href={"https://download.shibthemetaverse.io/shibportal-latest-setup.exe"}
                        className="flex items-center justify-center rounded-full border border-4 border-black bg-[#20110A] px-4 sm:px-5 sm:py-2 md:py-1.5 lg:py-1.5 text-center text-xs md:text-sm font-medium text-white hover:bg-orange-600 focus:outline-none shadow-[0px_2px_4px_0_rgba(0,0,0,0.4)] backdrop-blur-[24px]"
                    >
                        <Image
                            src="/logos/shib_portal_icon.svg"
                            alt="shibportal-logo"
                            width={80}
                            height={80}
                            className="mr-2"
                        />
                        <div className="flex flex-col space-y-1 items-start">
                            <div className="font-sora text-xs font-normal leading-[12px] text-left decoration-skip-ink-none sm:text-[12px] sm:leading-[14px]">
                                {t('download')}
                            </div>
                            <div className="font-sora text-xs font-semibold leading-[12px] text-left decoration-skip-ink-none sm:text-[12px] sm:leading-[14px]">
                                <Image
                                    src="/logos/shib_portal_border.svg"
                                    alt="shibportal-logo"
                                    width={120}
                                    height={120}
                                    className="mr-2"
                                />
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="flex justify-center items-center my-8 w-full md:w-[45%]">
                    <iframe
                        width="100%"
                        height="auto"
                        src="https://www.youtube.com/embed/9lxdqcPSb8o"
                        title="Lap Dogs Trailer"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="aspect-video"
                    ></iframe>
                </div>
            </div>
        </Section>
    );
};

export default LapDogs;